'use client';

import { createContext, useContext } from 'react';

// Types
import { Context, ProviderProps } from '@/types/contexts/clinicDetailsContext';

export const ClinicDetailsContext = createContext<Context>({
  clinicServicesContent: undefined,
});

export const ClinicDetailsProvider = ({
  children,
  clinicServicesContent,
}: ProviderProps) => (
  <ClinicDetailsContext.Provider
    value={{
      clinicServicesContent: clinicServicesContent,
    }}
  >
    {children}
  </ClinicDetailsContext.Provider>
);

export const useClinicDetailsContext = () =>
  useContext<Context>(ClinicDetailsContext);
